module.exports = __webpack_public_path__ + "img/DE00974.d6f0ff35.png";